export const state = {
    orderDetail: null, // buy esim 
    detailPaymentInfo: null,
    itemOrderDetail: null,   // item my-order detail
}

export const mutations = {
    SET_PAYMENT_DETAIL(state, newValue) {
        state.detailPaymentInfo = newValue
    },
    SET_ORDER_DETAIL(state, newValue) {
        state.orderDetail = newValue
    },
    SET_ITEM_ORDER_DETAIL(state, newValue) {
        state.itemOrderDetail = newValue
    }
}

export const getters = {
    getDetailPaymentInfo(state) {
        return state.detailPaymentInfo
    },
    getOrderDetail(state) {
        return state.orderDetail
    },
    getItemOrderDetail(state) {
        return state.itemOrderDetail
    }

}

export const actions = {
    async detailPaymentInfo({ commit }, value) {
        commit("SET_PAYMENT_DETAIL", value)
    },
    async clearPaymentDetail({ commit }) {
        commit("SET_PAYMENT_DETAIL", null)
    },
    async orderDetail({ commit }, value) {
        commit("SET_ORDER_DETAIL", value)
    },
    async clearOrderDetail({ commit }) {
        commit("SET_ORDER_DETAIL", null)
    },
    async itemOrderDetail({ commit }, value) {
        commit("SET_ITEM_ORDER_DETAIL", value)
    },
    async clearItemOrderDetail({ commit }) {
        commit("SET_ITEM_ORDER_DETAIL", null)
    }
}